/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiSearchFilter } from './InternalApiSearchFilter';
import {
    InternalApiSearchFilterFromJSON,
    InternalApiSearchFilterFromJSONTyped,
    InternalApiSearchFilterToJSON,
    InternalApiSearchFilterToJSONTyped,
} from './InternalApiSearchFilter';
import type { InternalApiLogicalOperator } from './InternalApiLogicalOperator';
import {
    InternalApiLogicalOperatorFromJSON,
    InternalApiLogicalOperatorFromJSONTyped,
    InternalApiLogicalOperatorToJSON,
    InternalApiLogicalOperatorToJSONTyped,
} from './InternalApiLogicalOperator';
import type { InternalApiPersonCategory } from './InternalApiPersonCategory';
import {
    InternalApiPersonCategoryFromJSON,
    InternalApiPersonCategoryFromJSONTyped,
    InternalApiPersonCategoryToJSON,
    InternalApiPersonCategoryToJSONTyped,
} from './InternalApiPersonCategory';
import type { InternalApiSortDirection } from './InternalApiSortDirection';
import {
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionFromJSONTyped,
    InternalApiSortDirectionToJSON,
    InternalApiSortDirectionToJSONTyped,
} from './InternalApiSortDirection';

/**
 * 
 * @export
 * @interface InternalApiPersonSearchQuery
 */
export interface InternalApiPersonSearchQuery {
    /**
     * 
     * @type {string}
     * @memberof InternalApiPersonSearchQuery
     */
    orderBy?: string;
    /**
     * 
     * @type {InternalApiSortDirection}
     * @memberof InternalApiPersonSearchQuery
     */
    direction?: InternalApiSortDirection;
    /**
     * 
     * @type {Array<InternalApiSearchFilter>}
     * @memberof InternalApiPersonSearchQuery
     */
    filters: Array<InternalApiSearchFilter>;
    /**
     * 
     * @type {InternalApiLogicalOperator}
     * @memberof InternalApiPersonSearchQuery
     */
    logicalOperator: InternalApiLogicalOperator;
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonSearchQuery
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonSearchQuery
     */
    size: number;
    /**
     * 
     * @type {InternalApiPersonCategory}
     * @memberof InternalApiPersonSearchQuery
     */
    category: InternalApiPersonCategory;
}



/**
 * Check if a given object implements the InternalApiPersonSearchQuery interface.
 */
export function instanceOfInternalApiPersonSearchQuery(value: object): value is InternalApiPersonSearchQuery {
    if (!('filters' in value) || value['filters'] === undefined) return false;
    if (!('logicalOperator' in value) || value['logicalOperator'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function InternalApiPersonSearchQueryFromJSON(json: any): InternalApiPersonSearchQuery {
    return InternalApiPersonSearchQueryFromJSONTyped(json, false);
}

export function InternalApiPersonSearchQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPersonSearchQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'orderBy': json['orderBy'] == null ? undefined : json['orderBy'],
        'direction': json['direction'] == null ? undefined : InternalApiSortDirectionFromJSON(json['direction']),
        'filters': ((json['filters'] as Array<any>).map(InternalApiSearchFilterFromJSON)),
        'logicalOperator': InternalApiLogicalOperatorFromJSON(json['logicalOperator']),
        'page': json['page'],
        'size': json['size'],
        'category': InternalApiPersonCategoryFromJSON(json['category']),
    };
}

export function InternalApiPersonSearchQueryToJSON(json: any): InternalApiPersonSearchQuery {
    return InternalApiPersonSearchQueryToJSONTyped(json, false);
}

export function InternalApiPersonSearchQueryToJSONTyped(value?: InternalApiPersonSearchQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderBy': value['orderBy'],
        'direction': InternalApiSortDirectionToJSON(value['direction']),
        'filters': ((value['filters'] as Array<any>).map(InternalApiSearchFilterToJSON)),
        'logicalOperator': InternalApiLogicalOperatorToJSON(value['logicalOperator']),
        'page': value['page'],
        'size': value['size'],
        'category': InternalApiPersonCategoryToJSON(value['category']),
    };
}

